"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledButtonIcon = exports.StyledSearchButton = exports.default = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledSystem = require("styled-system");

var _inputIconToggle = _interopRequireDefault(require("../../__internal__/input-icon-toggle/input-icon-toggle.style"));

var _inputPresentation = _interopRequireDefault(require("../../__internal__/input/input-presentation.style"));

var _input = _interopRequireDefault(require("../../__internal__/input/input.style"));

var _icon = _interopRequireDefault(require("../icon/icon.style"));

var _button = _interopRequireDefault(require("../button/button.style"));

var _themes = require("../../style/themes");

var _formField = _interopRequireDefault(require("../../__internal__/form-field/form-field.style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const StyledSearch = _styledComponents.default.div`
  ${({
  isFocused,
  searchWidth,
  searchIsActive,
  searchHasValue,
  showSearchButton,
  theme,
  variant
}) => {
  const darkVariant = variant === "dark";
  const variantColor = darkVariant ? `${theme.search.darkVariantBorder}` : `${theme.search.passive}`;
  const iconColor = darkVariant && (searchHasValue && isFocused || !searchHasValue && isFocused || !isFocused && searchHasValue && showSearchButton);
  return (0, _styledComponents.css)`
      ${_styledSystem.margin}
      width: ${searchWidth ? `${searchWidth}` : "100%"};
      padding-bottom: 2px;
      background-color: transparent;
      border-bottom: 2px solid ${variantColor};
      display: inline-flex;
      font-size: 14px;
      font-weight: 700;
      :hover {
        border-bottom-color: ${theme.search.active};
        cursor: pointer;
      }
      ${(isFocused || searchHasValue) && (0, _styledComponents.css)`
        border-color: transparent;
        transition: background 0.2s ease;
        color: ${theme.icon.defaultHover};
        :hover {
          border-color: transparent;
        }
      `}
      ${isFocused && !searchIsActive && (0, _styledComponents.css)`
        border-color: transparent;
        color: ${theme.icon.defaultHover};
      `}
      ${!isFocused && searchHasValue && !showSearchButton && (0, _styledComponents.css)`
        border-bottom: 2px solid ${variantColor};
        :hover {
          border-bottom-color: ${theme.search.active};
          cursor: pointer;
        }
      `}

      ${_input.default} {
        ${darkVariant && !isFocused && (0, _styledComponents.css)`
          ::-moz-placeholder {
            color: ${theme.search.darkVariantPlaceholder};
            opacity: 1;
          }
          ::placeholder {
            color: ${theme.search.darkVariantPlaceholder};
          }
        `}

        ${darkVariant && (0, _styledComponents.css)`
          ${!isFocused && searchHasValue && !showSearchButton && (0, _styledComponents.css)`
            color: ${theme.search.darkVariantText};
          `}
          ${!isFocused && !searchHasValue && (0, _styledComponents.css)`
            color: ${theme.search.darkVariantPlaceholder};
          `}
        `}
      }

      ${_inputPresentation.default} {
        background-color: ${searchHasValue || isFocused ? `${theme.colors.white}` : "transparent"};
        flex: 1;
        font-size: 14px;
        font-weight: 700;
        padding-bottom: 2px;
        padding-top: 1px;
        cursor: pointer;
        ${!isFocused && !searchHasValue && (0, _styledComponents.css)`
          border: 1px solid transparent;
          color: ${theme.icon.default};
        `}
        ${!isFocused && searchHasValue && !showSearchButton && (0, _styledComponents.css)`
          border: 1px solid transparent;
          background-color: ${darkVariant ? "transparent" : `${theme.colors.white}`};
        `}
      }

      ${_formField.default} {
        flex: 1;
        z-index: ${theme.zIndex.smallOverlay};
      }
      ${_button.default} {
        background-color: ${theme.search.button};
        cursor: pointer;
        color: ${theme.colors.white};
      }
      ${_icon.default} {
        color: ${iconColor ? `${theme.search.icon}` : `${theme.search.iconDarkVariant}`};
        ${!darkVariant && (0, _styledComponents.css)`
          color: ${theme.search.icon};
        `}

        width: 20px;
        height: 20px;
        cursor: pointer;
        :hover {
          color: ${iconColor ? `${theme.search.iconHover}` : `${theme.search.iconDarkVariantHover}`};
          ${!darkVariant && (0, _styledComponents.css)`
            color: ${theme.search.iconHover};
          `}
        }
      }

      ${_inputIconToggle.default} {
        ${searchHasValue && (0, _styledComponents.css)`
          margin-bottom: -1px;
        `}
      }
    `;
}}
`;
StyledSearch.defaultProps = {
  theme: _themes.baseTheme
};
var _default = StyledSearch;
exports.default = _default;
const StyledSearchButton = _styledComponents.default.div`
  display: inline-flex;
  border-bottom: none;
  &&& ${_button.default} {
    ${({
  theme
}) => (0, _styledComponents.css)`
      background-color: ${theme.colors.primary};
      border-color: ${theme.colors.primary};
      :hover {
        background: ${theme.colors.secondary};
        border-color: ${theme.colors.secondary};
      }
    `}

    width: 40px;
    margin: 0px 0px;
    padding-bottom: 3px;
    :focus {
      z-index: ${({
  theme
}) => theme.zIndex.smallOverlay};
    }
  }
`;
exports.StyledSearchButton = StyledSearchButton;
const StyledButtonIcon = _styledComponents.default.div`
  &&& ${_icon.default} {
    color: white;
    margin-right: 0px;
  }
`;
exports.StyledButtonIcon = StyledButtonIcon;
StyledSearchButton.defaultProps = {
  theme: _themes.baseTheme
};